export const THICKNESS_DASHBOARD = {
  namespaced: true,
  state: {
    // Keep alive
    viewerOpened: false,
    selectedRowsData: [],
    coloredInspections: [],
    checkRemainingLife: false,
    checkMinThickness: false,
  },
  getters: {
    GET_VIEWER_OPENED(state) {
      return state.viewerOpened;
    },
    GET_SELECTED_ROWS_DATA(state) {
      return state.selectedRowsData;
    },
    GET_COLORED_INSPECTIONS(state) {
      return state.coloredInspections;
    },
    GET_CHECK_REMAINING_LIFE(state) {
      return state.checkRemainingLife;
    },
    GET_CHECK_MIN_THICKNESS(state) {
      return state.checkMinThickness;
    }
  },
  mutations: {
    SET_VIEWER_OPENED(state, value) {
      state.viewerOpened = value;
    },
    SET_SELECTED_ROWS_DATA(state, value) {
      state.selectedRowsData = value;
    },
    SET_COLORED_INSPECTIONS(state, value) {
      state.coloredInspections = value;
    },
    SET_CHECK_REMAINING_LIFE(state, value) {
      state.checkRemainingLife = value;
    },
    SET_CHECK_MIN_THICKNESS(state, value) {
      state.checkMinThickness = value;
    }
  },
  actions: {
    RESET({ commit }) {
      commit('SET_VIEWER_OPENED', false);
      commit('SET_SELECTED_ROWS_DATA', []);
      commit('SET_COLORED_INSPECTIONS', []);
      commit('SET_CHECK_REMAINING_LIFE', false);
      commit('SET_CHECK_MIN_THICKNESS', false);
    }
  }
}